'use client';

import {
  Cookie as CookieClient,
  createRealTimeCookie,
} from '@cookie-baker/browser';
import type { CartItem } from '@generated-client/backend';
import { action } from '@reatom/core';
import { atom } from '@reatom/framework';
import { reatomCookie } from '@reatom/npm-cookie-baker';
import { cartAtom, likeEffect, likesAtom } from '@trwl/store';
import { referrerNameAction, saveCartItemsAction } from '@trwl/store/actions';

type authCookieModel = {
  accessToken?: string;
  refreshToken?: string;
  referrerId?: string;
  visitorId?: string;
};

const cookie = new CookieClient<authCookieModel>();
const realTimeCookie = createRealTimeCookie(cookie);

export const authAtom = reatomCookie(cookie, realTimeCookie);

export const isAuthedAtom = atom((ctx) => {
  const cookieObject = ctx.spy(authAtom.cookieAtom);
  return !!cookieObject.accessToken;
});

authAtom.cookieAtom.onChange((ctx, newState) => {
  const referrerId = newState.referrerId;
  const referrerIdNumber = parseInt(referrerId || '');
  referrerNameAction(
    ctx,
    isNaN(referrerIdNumber) ? undefined : referrerIdNumber,
  );
});

export const onLoginAction = action((ctx) => {
  const cart = ctx.get(cartAtom);
  const likes = ctx.get(likesAtom);
  const cartItems: CartItem[] = cart.map((i) => ({
    variantId: i.id,
    airplaneDelivery: i.airplaneDelivery || false,
    count: i.count,
  }));
  saveCartItemsAction(ctx, { cartItems });
  likes.forEach((like) => {
    likeEffect(ctx, like.id);
  });
});
